
    import '/opt/buildhome/repo/packages/x/docs/x-sdk/use-x-conversations.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-x-sdk-use-x-conversations-demo-basic","docs-x-sdk-use-x-conversations-demo-operations","docs-x-sdk-use-x-conversations-demo-multi-instances"],
  getter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/x-sdk/use-x-conversations.en-US.md?type=demo')
};